export enum ValidTypes {
  CustomTextInput = "CustomTextInput",
  CustomDatePicker = "CustomDatePicker",
  CustomDateTimePicker = "CustomDateTimePicker",
  CustomTimePicker = "CustomTimePicker",
  CustomRadioGroup = "CustomRadioGroup",
  CustomNumberInput = "CustomNumberInput",
  ColorPicker = "ColorPicker",
  CustomSelect = "CustomSelect",
  CustomCheckboxGroup = "CustomCheckboxGroup",
  CustomCheckbox = "CustomCheckbox",
  PlainLabel = "PlainLabel",
  ValueSlider = "ValueSlider",
  HiddenStaticValue = "HiddenStaticValue",
  HiddenValueCalculator = "HiddenValueCalculator",
}

export const isValidType = (type: string): type is ValidTypes => {
  return (
    type === "CustomTextInput" ||
    type === "CustomDatePicker" ||
    type === "CustomDateTimePicker" ||
    type === "CustomTimePicker" ||
    type === "CustomRadioGroup" ||
    type === "CustomNumberInput" ||
    type === "CustomCheckboxGroup" ||
    type === "CustomCheckbox" ||
    type === "ColorPicker" ||
    type === "CustomSelect" ||
    type === "ValueSlider" ||
    type === "HiddenStaticValue" ||
    type === "HiddenValueCalculator"
  );
};
